var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUncheckedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.203,
    d: "M4.82715 0.519043H14.4424C16.8212 0.519043 18.75 2.44874 18.75 4.82959V14.4507C18.7498 16.8314 16.8211 18.7612 14.4424 18.7612H4.82715C2.4485 18.7612 0.519729 16.8313 0.519531 14.4507V4.82959C0.519531 2.44877 2.44838 0.519084 4.82715 0.519043Z",
    fill: "white",
    stroke: "#E3E3ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4423 0.5H4.82692C2.43723 0.5 0.5 2.43833 0.5 4.82938V14.4502C0.5 16.8413 2.43723 18.7796 4.82692 18.7796H14.4423C16.832 18.7796 18.7692 16.8413 18.7692 14.4502V4.82938C18.7692 2.43833 16.832 0.5 14.4423 0.5Z",
    fill: "#F9F9FA",
    stroke: "#E3E3ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedIcon);
export default __webpack_public_path__ + "static/media/unchecked-icon.fffcdd8a7cc5532eb711d712d2b32b3b.svg";
export { ForwardRef as ReactComponent };